/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CcmLeakedResourceStatusEnum = 'CANDIDATE' | 'CLEANING' | 'CLEANED' | 'FAILED';

export const CcmLeakedResourceStatusEnum = {

    CANDIDATE: 'CANDIDATE' as CcmLeakedResourceStatusEnum,

    CLEANING: 'CLEANING' as CcmLeakedResourceStatusEnum,

    CLEANED: 'CLEANED' as CcmLeakedResourceStatusEnum,

    FAILED: 'FAILED' as CcmLeakedResourceStatusEnum
};

